// Shared AEM servlet paths used by Power Portal user/profile related components.
export const CURRENT_USER_SERVLET = '/libs/granite/security/currentuser.json'
export const POWERPORTAL_USER_PROFILE_SERVLET = '/bin/pg/powerportal-userprofile.json'
export const PERSONALIZATION_MAPPING_SERVLET = '/bin/pg/powerportal/personalization-mapping.json'
